import { useState } from "react";
import { useNotification } from "../../App/State/Hooks/notificationHooks";
import { ICandidate } from "../../App/Typings/Candidate";
import { useRemoveGroupMemberMutation } from "../../App/Queries/GroupQueries";

export type RemoveGroupMemberStateType = ReturnType<typeof RemoveGroupMemberState>;

export default function RemoveGroupMemberState(groupId: string, candidates: ICandidate[]) {
  const { displayError, displaySuccess } = useNotification();
  const [candidateToRemove, setCandidateToRemove] = useState<ICandidate>({} as ICandidate);
  const [confirmRemoveDialogOpen, setConfirmRemoveDialogOpen] = useState(false);
  const removeMemberMutation = useRemoveGroupMemberMutation();

  const handleRemoveCandidateFromGroup = async () => {
    if (candidates.length > 0 && candidateToRemove) {
      removeMemberMutation.mutate(
        {
          groupId,
          candidateId: candidateToRemove.id,
        },
        {
          onError: () => displayError("There was an error removing candidate from group. Please try again."),
          onSuccess: () => {
            displaySuccess("Candidate removed from group successfully!");
          },
        }
      );
    }
    setConfirmRemoveDialogOpen(false);
    setTimeout(() => {
      setCandidateToRemove({} as ICandidate);
    }, 300);
  };

  const handleSelectCandidateToRemove = (candidateId: string) => {
    const candidate = candidates.find((candidate: ICandidate) => candidate.id === candidateId);
    if (candidate) {
      setCandidateToRemove(candidate);
      setConfirmRemoveDialogOpen(true);
    }
  };

  const handleCloseConfirmRemoveDialog = () => {
    setCandidateToRemove({} as ICandidate);
    setConfirmRemoveDialogOpen(false);
  };

  return {
    handlers: {
      handleRemoveCandidateFromGroup,
      handleSelectCandidateToRemove,
      handleCloseConfirmRemoveDialog,
    },
    getters: {
      candidateToRemove,
      confirmRemoveDialogOpen,
    },
  } as const;
}
